"use client";

import { useLogoutWithCleanup } from "@/components/hooks/use-logout-with-cleanup";
import { Button, buttonVariants } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { useToast } from "@/components/ui/use-toast";
import { cn } from "@/lib/utils";
import { pagesPath } from "@/utils/pages-path";
import ProfileIcon from "@public/icons/profile-icon.svg";
import Link from "next/link";
import { useRouter } from "next/navigation";
import { useState } from "react";
import { MdExpandMore } from "react-icons/md";

export const MemberAccountActionMenu = ({ userName }: { userName: string }) => {
  const router = useRouter();
  const { logout } = useLogoutWithCleanup();
  const [isOpen, setIsOpen] = useState(false);
  const toggle = () => setIsOpen((p) => !p);
  const close = () => setIsOpen(false);
  const { toast } = useToast();

  return (
    <DropdownMenu open={isOpen}>
      <DropdownMenuTrigger asChild>
        <Button
          id="account-menu-button"
          className={cn(
            buttonVariants({ variant: "primary" }),
            "group w-10 rounded-full lg:w-auto",
          )}
          onClick={toggle}
        >
          <div className="hidden items-center lg:inline-flex">
            {userName}
            <MdExpandMore
              className="relative top-px ml-1 h-3 w-3 transition duration-200 group-data-[state=open]:rotate-180"
              aria-hidden="true"
            />
          </div>
          <span className="lg:hidden">
            <ProfileIcon className="h-6 w-6" />
          </span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        className="bg-white"
        onCloseAutoFocus={close}
        onEscapeKeyDown={close}
        onPointerDownOutside={close}
        onInteractOutside={close}
        onFocusOutside={close}
      >
        <DropdownMenuItem asChild>
          <Button
            asChild
            variant="ghost"
            className="w-full cursor-pointer focus-visible:ring-0 focus-visible:ring-inset"
          >
            <Link
              href={pagesPath.members.account.setting.$url().path}
              onClick={close}
            >
              アカウント
            </Link>
          </Button>
        </DropdownMenuItem>
        <DropdownMenuItem asChild>
          <Button
            variant="ghost"
            className="w-full cursor-pointer focus-visible:ring-0 focus-visible:ring-inset"
            onClick={async () => {
              close();
              await logout();
              // memo: こうするとLoginFallbackに入るのを防げることが多い
              setTimeout(() => {
                router.push(pagesPath.members.login.$url().path);
              }, 0);
              toast({
                title: "ログアウトしました",
                variant: "info",
              });
            }}
          >
            ログアウト
          </Button>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
